import Box from "@mui/material/Box";
import { StationOpeningHoursRow } from "../types";
import { getOpeningHoursDisplayLines } from "../helpers/getOpeningHoursDisplayLines";

interface EuropcarStationOpeningHoursProps {
  label: string;
  rows: StationOpeningHoursRow[];
}

export default function EuropcarStationOpeningHours({ label, rows }: EuropcarStationOpeningHoursProps) {
  if (!rows?.length) return null;

  return (
    <Box className="europcar__opening-hours" mt={6} ml={1} data-cy="europcar-opening-hours">
      <Box className="europcar__opening-hours-label">{label}</Box>
      {rows.map((row, index) => (
        <Box key={`${row.days}-${index}`} className="europcar__opening-hours-row" mt={1}>
          <Box className="europcar__opening-hours-days">{row.days}:</Box>
          {getOpeningHoursDisplayLines(row.hours).map((line, lineIndex) => (
            <Box key={`${line}-${lineIndex}`} className="europcar__opening-hours-time">
              {line}
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
